/**
 * Precios PTB desde líneas del packing list comercial (Excel cargado en Invoice).
 */
import { gradoFromPackingRow, round2, round3 } from './invoicePtcMerchandise';
import { parseLogisticNum } from './logisticPackingListPricing';
import { groupCommercialRowsByConfig } from './logisticPackingListPricing';

function safe(v) {
  return v == null ? '' : String(v);
}

export function commercialLineHasPrecio(row) {
  return (
    parseLogisticNum(row?.precio_usd_m3) != null || parseLogisticNum(row?.total_usd) != null
  );
}

export function commercialLineasTienenPrecios(lineas) {
  const rows = (lineas || []).filter((row) => {
    const m3 = parseLogisticNum(row?.total_m3);
    return m3 != null && m3 > 0;
  });
  if (!rows.length) return false;
  return rows.some(commercialLineHasPrecio);
}

/** Suma M³ y USD desde columnas del Excel comercial (Proveedor usd/m³, Total usd).
 *  PTB: total de grupo = Σ «Total usd»; unitario mostrado = Σ USD ÷ Σ M³ (ponderado). */
export function aggregateCommercialPricingForRows(commercialRows) {
  let sumM3 = 0;
  let sumUsd = 0;
  const unitSamples = new Set();

  for (const row of commercialRows || []) {
    const m3 = parseLogisticNum(row?.total_m3);
    const unit = parseLogisticNum(row?.precio_usd_m3);
    let total = parseLogisticNum(row?.total_usd);
    if (total == null && unit != null && m3 != null && m3 > 0) {
      total = round2(unit * m3);
    }
    if (m3 != null && m3 > 0) sumM3 += m3;
    if (total != null && total > 0) sumUsd += total;
    if (unit != null) unitSamples.add(unit);
  }

  const sumUsdRounded = round2(sumUsd);
  let unitPriceUsd = null;
  if (sumM3 > 0 && sumUsdRounded > 0) {
    unitPriceUsd = round2(sumUsdRounded / sumM3);
  } else if (unitSamples.size === 1) {
    unitPriceUsd = [...unitSamples][0];
  }

  return {
    sumM3: round3(sumM3),
    sumUsd: sumUsdRounded,
    unitPriceUsd,
  };
}

export function mensajePtbSinPreciosComercial(commercialLineas) {
  const sinPrecio = (commercialLineas || []).filter((row) => {
    const m3 = parseLogisticNum(row?.total_m3);
    return m3 != null && m3 > 0 && !commercialLineHasPrecio(row);
  });
  if (!sinPrecio.length) {
    return (
      'No hay precios PTB en el packing list comercial. Vuelva a cargar el Excel en Invoice ' +
      '(columnas «Proveedor usd/m³» y «Total usd»). La Invoice PTB no utiliza precios de la PI.'
    );
  }
  const detalle = sinPrecio
    .slice(0, 5)
    .map((row) => {
      const nf = safe(row?.nf_celda).trim() || '—';
      const grado = gradoFromPackingRow(row) || '—';
      return `NF ${nf} / grado ${grado}`;
    })
    .join('; ');
  const extra = sinPrecio.length > 5 ? ` (+${sinPrecio.length - 5} líneas más)` : '';
  return (
    `Faltan precios PTB en el Excel del packing list comercial (${detalle}${extra}). ` +
    'Revise «Proveedor usd/m³» o «Total usd» y vuelva a cargar el archivo. La Invoice PTB no utiliza precios de la PI.'
  );
}

export { groupCommercialRowsByConfig, merchGroupKeyFromLinea } from './logisticPackingListPricing';
